import React, { PropsWithChildren } from 'react'
import ItemDetailMedia, { ItemDetailMediaProps } from './ItemDetailMedia'

const ItemDetail: React.FC<PropsWithChildren<ItemDetailMediaProps>> = ({
  children,
  itemName,
  itemImage,
  vendorName,
  vendorLogo,
}) => {
  return (
    <>
      <ItemDetailMedia
        itemName={itemName}
        vendorName={vendorName}
        vendorLogo={vendorLogo}
        itemImage={itemImage}
      />
      {children}
    </>
  )
}

export default ItemDetail
